$(document).ready(function (){
//    var time = new Date();
//   var countDownDate = new Date(time); 
//   var x = setInterval(function() { 
//     var now = new Date().getTime();
//     // Find the distance between now and the count down date
//     var distance = countDownDate - now;  
//     // Time calculations for days, hours, minutes and seconds 
//     var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//     var seconds = Math.floor((distance %  (1000 * 60)) / 1000);
//     // Output the result in an element with id="ctt_timer_show"


//     document.getElementById("hour").innerText = hours ;
//     document.getElementById("minute").innerText = minutes ;
//     document.getElementById("second").innerText = seconds ;
    
//     if (distance < 0) {
//  clearInterval(x);
//       document.getElementById("hour").innerText = hours ;
//     document.getElementById("minute").innerText = minutes ;
//   document.getElementsByClassName("custom-time").innerText = seconds ;
//      }
// }, 1000);

// $('.header__inline-menu>ul>li summary').click(function() {
//     $(this).parent().find('.itg-mega-scrollar.mega-menu__list').find('.itg-mega-menu').each(function () {
//         var has_sub = $(this).hasClass('itg-sub-menu');
//         if(has_sub == true){
//             $(this).find('.itg-mega-scrollar').show();
//             return false;
//         }
//     });
    
//       $('.itg-sub-menu').hover(function(){
//       //   alert();
//       $('ul.list-unstyled').css("display", "none");
//       $(this).find('ul.list-unstyled').css("display", "block");
//     });
// });

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    
  });
  
  });
$('details').hover(function(){
    $(this).find('.itg-mega-scrollar.mega-menu__list').find('.itg-sub-menu').each(function (){
        var has_sub = $(this).hasClass('itg-sub-menu');
        if(has_sub == true){
          // alert();
            $(this).find('ul.list-unstyled').show();
            return false;  
        }
      });
    });
   $('.itg-sub-menu').hover(function(){
     
      //   alert();
      $('.itg-header-menu ul.list-unstyled').css("display", "none");
      $(this).find('ul.list-unstyled').css("display", "block");
    });
  
    $('.itg-mega-menu').hover(function(){
     var done =  $(this).attr('coll_image');
   // alert(done);

     $('.mega-menu-img img').attr("src", done);
      
    });
  
});


document.addEventListener("DOMContentLoaded", function() {
    var listItems = document.querySelectorAll('.thumbnail-list__item');
    if (listItems.length > 1) {
        listItems[1].parentNode.removeChild(listItems[1]);
    }
});

